import api from './api';

// API通信を管理する関数
const apiService = {
  getAccount(id) {
    return api.get(`/account/${id}`);
  },
  login(loginId, password) {
    return api.post('/auth/login', { loginId, password });
  },
  getCategoryList() {
    return api.get('/common/get-categories');
  },
  getMakerList() {
    return api.get('/common/get-makers');
  },
  getPublicStateList() {
    return api.get('/common/get-public-states');
  },
  getAccountList() {
    return api.get('/common/get-accounts');
  },
  getStoreList() {
    return api.get('/common/get-stores');
  },
  getProductStatusList() {
    return api.get('/common/get-product-statuses');
  },
  getTagList() {
    return api.get('/common/get-tags');
  },
  getRankList() {
    return api.get('/common/get-ranks');
  },
  getSalesChannelList() {
    return api.get('/common/get-sales-channels');
  },
  getAccessoryList() {
    return api.get('/common/get-accessories');
  },
  getProductDescriptionTemplate(categoryId, rankId) {
    return api.get(`/common/get-product-description-template?categoryId=${categoryId}&rankId=${rankId}`);
  },
  // 商品登録管理
  registerProductInfo(productData) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    return api.post('/products/register', productData, {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },

  // 買取情報から商品登録
  registerProductInfoFromPurchaseSlip(id){
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    return api.post(`/products/register-common-purchase-slipId/${id}`, {}, {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },
  getProductById(id) {
    return api.get(`/products/${id}`);
  },
  getProductList(params) {
    return api.get(`/products/search?${params.toString()}`);
  },
  bulkDeleteProducts(productIds) {
    return api.put('/products/bulk-delete', {
      productIds: productIds
    });
  },
  bulkPublishProducts(productIds, publicStateId, salesChannelId) {
    return api.put('/products/bulk-publish', {
      productIds: productIds,
      publicStateId: publicStateId,
      selectedSalesChannelId: salesChannelId,
    });
  },
  getProductsByIds(productIds) {
    return api.post('/products/get-by-ids', {
      productIds: productIds
    });
  },
  updateProductsRank(productIds, rankId) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    return api.put('/products/bulk-update-rank', {
      productIds: productIds,
      rankId: rankId
    },
    {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    }
  );
  },
  updateProductsPrice(priceUpdateData) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    return api.post('/products/update-price', priceUpdateData, {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },
  registerMaker(makerData) {
    return api.post('/maker/register', makerData);
  },
  updateMaker(id, makerData) {
    return api.put(`/maker/update/${id}`, makerData);
  },
  deleteMaker(id) {
    return api.delete(`/maker/delete/${id}`);
  },
  updateMakerDisplayOrder(makerIds) {
    return api.put('/maker/update-display-order', { makerIds });
  },
  // 買取査定管理
  getPurchaseById(id) {
    return api.get(`/purchase/get-id/${id}`);
  },
  getSearchPurchases(params) {
    return api.get(`/purchase/get-search?${params.toString()}`);
  },
  updatePurchase(purchaseRequest) {
    return api.put('/purchase/update', purchaseRequest);
  },
  deletePurchase(id) {
    return api.delete(`/purchase/delete/${id}`);
  },
  registerPurchase(purchaseRequest) {
    return api.post('/purchase/register', purchaseRequest);
  },
  registerPurchaseProduct(purchaseRequest) {
    return api.post('/purchase/register-product', purchaseRequest);
  },
  generatePurchaseSlips(purchaseId) {
    return api.get(`/purchase/generate-slips/${purchaseId}`);
  },

  // ログ管理
  searchEventLogs(params) {
    return api.get('/event-logs/search', { params });
  },
  registerEventLogs(eventLogData) {
    return api.post('/event-logs/register', eventLogData);
  },

  // 店舗移動管理
  registerStoreTransfer(storeTransferRequest) {
    return api.post('/store-transfer/register', storeTransferRequest);
  },
  
  searchStoreTransfers(searchParams) {
    return api.get('/store-transfer/search', { params: searchParams });
  },
  
  getStoreTransferById(id) {
    return api.get(`/store-transfer/${id}`);
  },
  
  deleteStoreTransfer(id) {
    return api.delete(`/store-transfer/delete/${id}`);
  },
  
  registerShippingTransfer(requestData) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    return api.post('/store-transfer/shipping/register', requestData, {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },
  
  getStoreTransferArrivalDetails(id) {
    return api.get(`/store-transfer/arrival/${id}`);
  },

  getStoreTransferProductByCode(id, productCode) {
    return api.get(`/store-transfer/arrival/${id}/product`, { params: { productCode } });
  },

  registerArrivalTransfer(requestData) {
    return api.post('/store-transfer/arrival/register', requestData);
  },
  
  exportStoreTransferCSV(storeTransferIds) {
    return api.post('/store-transfer/export-csv', { storeTransferIds }, {
      responseType: 'blob'
    });
  },
  
  // 価格操作管理
  getPriceIncreaseList() {
    return api.get('/price-operation/price-increase-list');
  },

  getPriceCutList() {
    return api.get('/price-operation/price-cut-list');
  },
  
  getPriceOperationLatestUpdateDate(isIncrease) {
    return api.get('/price-operation/latest-update-date', {
      params: { isIncrease }
    });
  },

  updatePriceIncrease(categoryId, salesChannelId, details) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    console.log("encodedAccountName", encodedAccountName);
    return api.put(`/price-operation/update-price-increase`, {
      categoryId: categoryId,
      salesChannelId: salesChannelId,
      priceIncreaseDetail: details
    },
    {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },
  
  updatePriceCut(categoryId, salesChannelId, details, spans) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    // アカウント名エンコード（ISO-8859-1エラー回避のため）
    const encodedAccountName = encodeURIComponent(accountName);
    return api.put(`/price-operation/update-price-cut`, {
      categoryId: categoryId,
      salesChannelId: salesChannelId,
      priceCutDetail: details,
      priceCutSpan: spans
    },
    {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },
  // 売上管理
  exportSalesCSV(selectedInfo) {
    return api.post('/sales/export-file', selectedInfo, {
      responseType: 'blob'
    });
  },
  // アカウント管理
  getAllAccounts() {
    return api.get('/account/list');
  },
  updateAccount(id, accountData) {
    return api.put(`/account/${id}`, accountData);
  },

  // 印刷イベント管理
  generateLabelFromForm(formData) {
    return api.post('label/generate-form', formData);
  },
  
  generateBulkProductLabels(productIds) {
    return api.post('label/generate-bulk', {
      productIds: productIds
    });
  },
  updatePrintJobStatus(jobId, status) {
    return api.post('print-events/update-status', {
      jobId: jobId,
      status: status
    });
  },

  // 開発者モード
  // Shopify連携テスト
  registerToShopify(id) {
    return api.post(`/shopify-test/register/${id}`);
  },
  updateToShopify(id) {
    return api.put(`/shopify-test/update/${id}`);
  },
  deleteToShopify(id) {
    return api.delete(`/shopify-test/delete/${id}`);
  },
  // Shopifyへの一括登録：データ移行用
  bulkRegisterToShopify() {
    return api.post('/shopify-test/bulk-register');
  },
  // メルカリ連携テスト
  registerToMercari(id) {
    return api.post(`/mercari-test/register/${id}`);
  },
  updateToMercari(id) {
    return api.put(`/mercari-test/update/${id}`);
  },
  deleteToMercari(id) {
    return api.delete(`/mercari-test/delete/${id}`);
  },
  ordersToMercari() {
    return api.get(`/mercari-test/orders/get`);
  },
  createOrderToMercari(id) {
    return api.post(`/mercari-test/order/register/${id}`);
  },
  registerWebhookToMercari(webhookData) {
    return api.post('/mercari-test/webhook/register', webhookData);
  },
  getWebhooksFromMercari() {
    return api.get('/mercari-test/webhook/list');
  },
  completeOrderToMercari(orderId) {
    return api.post(`/mercari-test/order/complete/${orderId}`);
  },
  deleteOldSoldProducts() {
    return api.post('/product-batch-test/delete-old-sold-products');
  },
  registerToSmaregi(id) {
    return api.post(`/smaregi-test/register/${id}`);
  },
  updateToSmaregi(id) {
    return api.put(`/smaregi-test/update/${id}`);
  },
  deleteToSmaregi(id) {
    return api.delete(`/smaregi-test/delete/${id}`);
  },
  ordersToSmaregi() {
    return api.get(`/smaregi-test/orders/get`);
  },
  bulkDeleteAllFromSmaregi() {
    return api.post('/smaregi-test/bulk-delete-all');
  },
  bulkRegisterToSmaregi() {
    return api.post('/smaregi-test/bulk-register');
  },
  exportSmaregiCsv() {
    return api.post('/smaregi-test/export-csv', {}, {
      responseType: 'blob',
      timeout: 300000,
      headers: {
        'Accept': 'application/zip'
      }
    });
  },
  uploadSmaregiProductIds(formData) {
    return api.post('/smaregi-test/upload-smaregi-product-ids', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  // DataBase操作
  backupDatabase() {
    return api.post('/database/backup');
  },
  restoreDatabase(backupFileName) {
    return api.post('/database/restore', null, {
      params: { backupFileName }
    });
  },
  // CloudFlare画像一括アップロード：データ移行用
  allImageUpload() {
    return api.post('/database/all-image/upload');
  },
  
  // 棚卸管理
  registerInventory(inventoryRequest) {
    return api.post('/inventory/register', inventoryRequest);
  },

  updateInventoryCategory(data) {
    return api.post('/inventory/update-category', data);
  },

  getInventoryImplementation(data) {
    return api.post('/inventory/implementation', data);
  },

  searchProductForInventory(productCode, inventoryId) {
    return api.get('/inventory/search-product', { params: { productCode, inventoryId } });
  },

  registerInventoryDetail(data) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    const encodedAccountName = encodeURIComponent(accountName);
    return api.post('/inventory/register-detail', data, {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },

  getCurrentInventory(storeId) {
    return api.get('/inventory/get-current', { params: { storeId } });
  },

  getInventoryList(params) {
    return api.get('/inventory/list', { params });
  },

  downloadInventoryDiscrepancy(storeId) {
    return api.get('/inventory/download-discrepancy', {
      params: { storeId },
      responseType: 'blob'
    });
  },

  bulkInventoryUpdate(inventoryId) {
    const accountName = localStorage.getItem('accountName') || 'unknown';
    const encodedAccountName = encodeURIComponent(accountName);
    return api.post('/inventory/bulk-update', {
      inventoryId: inventoryId
    }, {
      headers: {
        'X-Account-Name': encodedAccountName
      }
    });
  },
};


export default apiService;
